import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/context/AuthProvider";
import AuthWidget from "../auth/components/AuthWidget";

const SubscribePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <main id="main" className="page-main" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section">
          <div className="page-section__body d-flex justify-content-center pt-5">
            <div style={{ width: "100%", maxWidth: "450px" }}>
              
              {!user ? (
                <>
                  <div className="text-center mb-4">
                    <h1 className="h4 fw-bold mb-1">Join Sustina</h1>
                    <p className="text-muted small">Create your account to get started</p>
                  </div>

                  <AuthWidget 
                    initialMode="REGISTER" 
                    onAuthenticated={() => {
                      navigate("/auth/sign-in", { replace: true });
                    }} 
                  />
                </>
              ) : (
                <div className="card border-0 shadow-sm p-4 text-center">
                  <h2 className="h5 fw-bold mb-3">Welcome Back</h2>
                  <p className="text-muted small">
                    You are already signed in as <strong>{user.email || user.userName}</strong>.
                  </p>
                  <div className="d-grid gap-2">
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate("/registered/dashboard")}
                    >
                      Go to Dashboard
                    </button>
                    <button 
                      className="btn btn-outline-secondary btn-sm" 
                      onClick={() => navigate("/auth/sign-in")}
                    >
                      Sign in to a different account
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default SubscribePage;